import { render, staticRenderFns } from "./Bianjiqi.vue?vue&type=template&id=abc5877e&"
import script from "./Bianjiqi.vue?vue&type=script&lang=js&"
export * from "./Bianjiqi.vue?vue&type=script&lang=js&"
import style0 from "./Bianjiqi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports